/** THIS IS AN AUTO GENERATED FILE, DO NOT EDIT MANUALLY -- Created by @graphql-codegen */
import * as Types from '../../shared/generated.types'

import { api } from '../../utils'
export const EmrSyncStatisticsResponseFragment = `
    fragment EmrSyncStatisticsResponseFragment on EmrSyncStatisticsResponse {
  emrSyncStatus
  lastSynced {
    date
  }
  message
}
    `
export const SyncToEmrDocument = `
    mutation syncToEmr($input: SyncToEmrInput!) {
  syncToEmr(input: $input) {
    ...EmrSyncStatisticsResponseFragment
  }
}
    ${EmrSyncStatisticsResponseFragment}`
export const SyncInsuranceToEmrDocument = `
    mutation syncInsuranceToEmr($input: SyncInsuranceToEmrInput!) {
  syncInsuranceToEmr(input: $input) {
    ...EmrSyncStatisticsResponseFragment
  }
}
    ${EmrSyncStatisticsResponseFragment}`

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    syncToEmr: build.mutation<Types.SyncToEmr, Types.SyncToEmrVariables>({
      query: (variables) => ({ document: SyncToEmrDocument, variables }),
    }),
    syncInsuranceToEmr: build.mutation<
      Types.SyncInsuranceToEmr,
      Types.SyncInsuranceToEmrVariables
    >({
      query: (variables) => ({
        document: SyncInsuranceToEmrDocument,
        variables,
      }),
    }),
  }),
})

export { injectedRtkApi as api }
